<template>
    <DCard
        padding
    >
        <div class="mt-2 mb-4 text-center">
            {{ __('tools.testing.date_manipulation.description') }}
        </div>
        <DForm @submit.prevent="execute">
            <DFormRow
                :label="__('tools.testing.date_manipulation.form.number_of_days')"
                is-required
            >
                <DInput
                    id="number-of-days"
                    v-model="form.days"
                    :placeholder="__('tools.testing.date_manipulation.form.number_of_days')"
                    add-input-classes="bg-light"
                    :is-valid="isFormFieldValid('days')"
                    :invalid-feedback="errors.days"
                    type="number"
                />
            </DFormRow>
            <DFormRow
                :label="__('tools.testing.date_manipulation.form.customer_id')"
                is-required
            >
                <DInput
                    id="customer-id"
                    v-model="form.customer_id"
                    :placeholder="__('tools.testing.date_manipulation.form.customer_id')"
                    add-input-classes="bg-light"
                    :is-valid="isFormFieldValid('customer_id')"
                    :invalid-feedback="errors.customer_id"
                    type="number"
                />
            </DFormRow>
            <DFormControls
                :submit-message="__('tools.testing.date_manipulation.form.execute')"
                @submit="execute"
            />
        </DForm>
    </DCard>
</template>

<script>
export default {
    name: 'DateManipulation',
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            form: this.$inertia.form({
                days: null,
                customer_id: null
            })
        }
    },
    methods: {
        execute () {
            this.form.post(this.$route('tools.date_manipulation.execute'))
        }
    }
}
</script>
